module.exports = __webpack_public_path__ + "static/media/marker--priority-orange.2cffff3d.svg";